import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'html',
    label: 'HTML Code',
    type: types.HTML,
    options: false
  }
];

const defaultProps = {
  html: `
    <h1>HTML Component</h1>
    <p>
      Use this component to add custom HTML to a section.
    </p>
  `
};

export default {
  title: 'HTML',
  id: 'HTML',
  propsSchema,
  defaultProps
};
